/*###########################################################################
// Enquiry
//#########################################################################*/

import { formatCurrency } from '../utilities/_commerce'

export function enquiry() {
  return {
		config: {
		},

		elements: {},

		init() {
		},

		getLineItemPrice(price, salePrice, qty) {
			if (salePrice) {
				return formatCurrency(salePrice * qty)
			} else {
				return formatCurrency(price * qty)
			}
		},

		getTotal(price) {
			return formatCurrency(this.$store.cart.totalPrice)
		}
	}
}
